import PropTypes from 'prop-types';
import { Loader2 } from 'lucide-react';

import { cn } from '#/lib/utils';

/**
 * 掃描查詢／Dialog 流程期間的全螢幕 cover。
 * busy cover（--z-busy-cover）：高於 Nav、低於 Radix overlay（--z-overlay）。
 */
const StockScanCoverOverlay = ({
  show = false,
  message = '查詢庫存中…',
  className = null,
}) => {
  if (!show) {
    return null;
  }

  return (
    <div
      className={cn(
        'bg-black/10 flex items-center justify-center',
        'fixed inset-0 z-[var(--z-busy-cover)] pointer-events-auto',
        'supports-backdrop-filter:backdrop-blur-xs',
        className,
      )}
      aria-busy="true"
      aria-live="polite"
      role="status"
    >
      <div
        className="
          flex flex-col items-center gap-3 rounded-md bg-panel/90 px-6 py-4 shadow-sm
        "
      >
        <Loader2 className="animate-spin text-gray-700" size={36} aria-hidden />
        <p className="text-sm text-gray-700">{message}</p>
      </div>
    </div>
  );
};

StockScanCoverOverlay.propTypes = {
  show: PropTypes.bool,
  message: PropTypes.string,
  className: PropTypes.string,
};

export default StockScanCoverOverlay;
